import React, { FunctionComponent, ReactNode } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';

export const LabeledBox: FunctionComponent<{
  title: string;

  sx?: SxProps<Theme>;
  contentSx?: SxProps<Theme>;

  children: ReactNode;
}> = (props) => (
  <Box sx={[{ flex: 1, m: 1, mt: 2 }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
    <Typography sx={{ pb: 1 }} variant="caption">
      {props.title}
    </Typography>

    <Box
      sx={[
        {
          border: 'solid 1px',
          borderColor: 'border.main',
        },
        ...(Array.isArray(props.contentSx) ? props.contentSx : [props.contentSx]),
      ]}
    >
      {props.children}
    </Box>
  </Box>
);
